import {BoxGeometry, Mesh} from "three";
import * as Globals from "../../globals";
import {toFixedFloat} from "../../utils/utils";
import {getVolume} from "../../utils/volumeUtils";
import {addEdgeGeometry} from "../../utils/threeUtils";
import {setObjectLayer} from "../../utils/layerUtils";
import {raehmSchwelleMaterial} from "../../constants/materialConstants";

export class Schwelle {
    constructor(width, height, thickness, position) {
        let schwelleGeometry = new BoxGeometry(width, thickness, height);
        let schwelleMesh = new Mesh(schwelleGeometry, raehmSchwelleMaterial);
        schwelleMesh.position.copy(position);
        schwelleMesh.name = "schwelleMesh";
        let volume = toFixedFloat(getVolume(schwelleMesh.geometry), 7);
        schwelleMesh.userData.originalVolume = volume;
        schwelleMesh.userData.sizedVolume = volume;
        schwelleMesh.userData.width = width;
        schwelleMesh.userData.height = height;
        schwelleMesh.userData.depth = thickness;
        addEdgeGeometry(schwelleMesh);
        setObjectLayer(schwelleMesh, Globals.layers.schwelle, true);
        return schwelleMesh;
    }
}
